export default {
  WALLETTOPUP: "Wallet Topup",
  TOPUP: "Topup",
};
